import * as sentryReact from '@sentry/react';
import { getTenantContext } from '@duke-hq/libctx';

const tenantContext = getTenantContext();

sentryReact.init({
  dsn: tenantContext?.apis?.SENTRY_DSN,
  environment: tenantContext?.environment,
  integrations: [
    new sentryReact.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['localhost', /^https:\/\/[a-zA-Z0-9-]+\.duke\.co\/trpc/],
    }),
    new sentryReact.Replay({
      networkDetailAllowUrls: ['/trpc/*'],
    }),
  ],
  enabled: tenantContext?.environment !== 'local',
  // Performance Monitoring
  tracesSampleRate: 0.2, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.5, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

export { sentryReact };
